module.exports = __webpack_public_path__ + "static/media/imageGiveaway.f8ce8e49.png";